import React, { useState, useEffect } from 'react'
import { useActions, useValues } from 'kea'
import PropTypes from 'prop-types'

import FloatingHeaderElements from './floating-header-elements'

import { clearFilterState } from '~/scenes/search/filters-page/utils.js'

import searchLogic from '~/scenes/search/logic.js'

const SearchHeaderElements = props => {
  const { hide, isMinHeader, forceMinVersion, isHeaderClass, isSearchPage, isInboxThreadPage, children } = props

  const [lastScrollTop, setLastScrollTop] = useState(0)
  const [headerBottomPosition, setHeaderBottomPosition] = useState(0)
  const [scrollDirection, setScrollDirection] = useState('down')
  const [headerClass, setHeaderClass] = useState('absolute-position')
  const { updateFilter } = useActions(searchLogic)
  const { showingFavourites, isSmallScreen } = useValues(searchLogic)

  const searchBarHeaderPart = typeof window !== 'undefined' && window.document.querySelector('.min-react-header')
  const searchPage =
    typeof window !== 'undefined' &&
    window.document.querySelector(isInboxThreadPage ? '.inbox-thread-scene' : '.search-page')
  const positionFix = 11 // The filters button are set on top of the minHeader, this will center them

  useEffect(() => {
    const updateHeaderPosition = (screenTop, searchPageRect, newScrollDirection, updateThreshold) => {
      if (screenTop === 0) {
        setHeaderClass('full-view')
      } else if (searchPageRect.top <= -updateThreshold) {
        if (newScrollDirection && newScrollDirection !== scrollDirection) {
          setScrollDirection(newScrollDirection)
          switch (newScrollDirection) {
            case 'up':
              // setHeaderClass(isMinHeader && !showingFavourites && !isSearchPage ? 'mid-view' : 'full-view')
              setHeaderClass(isMinHeader && !showingFavourites ? 'mid-view' : 'full-view')
              break
            case 'down':
              setHeaderClass('full-view')
              break
          }
        }
      }
    }

    const listener = () => {
      if (!forceMinVersion || !isMinHeader) {
        const screenTop = window.pageYOffset || window.document.documentElement.scrollTop
        const searchPageRect = searchPage ? searchPage.getBoundingClientRect() : null
        const updateThreshold = isMinHeader && searchBarHeaderPart ? searchBarHeaderPart.clientHeight - positionFix : 0
        let newScrollDirection

        if (screenTop > lastScrollTop) {
          newScrollDirection = 'up'
        } else if (screenTop === lastScrollTop) {
          // Do nothing
          // In IE this is an important condition because there seems to be some instances where the last scrollTop is equal to the new one
        } else {
          newScrollDirection = 'down'
        }

        setLastScrollTop(screenTop <= 0 ? 0 : screenTop)

        if (searchPage) {
          const header = document.querySelector('.search-page-header')

          if (header) {
            const newPosition = header.getBoundingClientRect().bottom

            if (header && newPosition !== headerBottomPosition) {
              setHeaderBottomPosition(newPosition)
            }

            const lowestBarLevel = searchPageRect.top

            if (lowestBarLevel > 0) {
              setHeaderClass('absolute-position')
            } else {
              if (headerClass === 'absolute-position' || headerClass === 'hide-view') {
                setHeaderClass(isMinHeader && searchPageRect.top < -58 ? 'mid-view' : 'full-view')
              } else {
                updateHeaderPosition(screenTop, searchPageRect, newScrollDirection, updateThreshold)
              }
            }
          }
        }
      } else if (forceMinVersion && headerClass !== 'mid-view') {
        setHeaderClass('mid-view')
      }
    }

    listener()
    window.addEventListener('scroll', listener)
    return () => {
      window.removeEventListener('scroll', listener)
    }
  }, [
    forceMinVersion,
    headerBottomPosition,
    headerClass,
    isInboxThreadPage,
    isMinHeader,
    lastScrollTop,
    scrollDirection,
    searchBarHeaderPart,
    searchPage,
    showingFavourites
  ])

  const performCategorySearch = (query, data) => {
    const { slug = '', is_tag: isTag, value, sub_category_id: subCategoryId } = data || {}

    updateFilter({
      query,
      query_slug: data ? slug : '',
      page: 1,
      zoom_out_if_needed: true,
      favourites: false,
      teacher_languages: '',
      category_tags: isTag ? String(value) : '',
      ...(isTag && { sub_category_ids: [subCategoryId] })
    })
  }

  const enableFavoritesPage = () => {
    updateFilter({
      ...clearFilterState({ filterType: null, isSmallScreen, allFilters: true }),
      favourites: true,
      page: 1
    })
  }

  const classname = `search-page-header${hide && !isMinHeader ? ' hide' : ''}${
    isHeaderClass || isSearchPage ? ` ${headerClass}` : ''
  }`

  return (
    <div className={classname}>
      <FloatingHeaderElements
        {...props}
        performSearch={performCategorySearch}
        enableFavoritesPage={enableFavoritesPage}
      />
      {children}
    </div>
  )
}

SearchHeaderElements.propTypes = {
  hide: PropTypes.bool,
  isMinHeader: PropTypes.bool,
  forceMinVersion: PropTypes.bool,
  isHeaderClass: PropTypes.bool,
  isSearchPage: PropTypes.bool,
  isInboxThreadPage: PropTypes.bool,
  children: PropTypes.node
}

export default SearchHeaderElements
